import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DEFAULT_LANG, isSupportedLang } from "@/i18n/languages";

export function useLocale() {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();

  const parts = pathname.split("/").filter(Boolean);
  const activeLang = isSupportedLang(parts[0]) ? parts[0] : DEFAULT_LANG;

  useEffect(() => {
    if (i18n.language !== activeLang) {
      i18n.changeLanguage(activeLang);
    }
  }, [activeLang, i18n]);

  return activeLang;
}